import { render, staticRenderFns } from "./LoginRouter.vue?vue&type=template&id=6670d971&scoped=true&"
import script from "./LoginRouter.vue?vue&type=script&lang=js&"
export * from "./LoginRouter.vue?vue&type=script&lang=js&"
import style0 from "./LoginRouter.vue?vue&type=style&index=0&id=6670d971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670d971",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6670d971')) {
      api.createRecord('6670d971', component.options)
    } else {
      api.reload('6670d971', component.options)
    }
    module.hot.accept("./LoginRouter.vue?vue&type=template&id=6670d971&scoped=true&", function () {
      api.rerender('6670d971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/LoginRouter.vue"
export default component.exports